import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TagsState } from './tags.reducer';

export const selectTagsState = createFeatureSelector<TagsState>('tags');

export const selectTags = createSelector(selectTagsState, (state) => state.tags);
export const selectTagsMeta = createSelector(selectTagsState, (state) => state.meta);
export const selectTagsLoading = createSelector(selectTagsState, (state) => state.isLoading);
export const selectTagsSubmitting = createSelector(selectTagsState, (state) => state.isSubmitting);
export const selectTagsDeleting = createSelector(selectTagsState, (state) => state.isDeleting);
export const selectTagsError = createSelector(selectTagsState, (state) => state.error);
export const selectTagsLastQuery = createSelector(selectTagsState, (state) => state.lastQuery);

